<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData">
      <template #handle>
        <div class="form-col handle-btns">
          <el-form-item>
            <el-button type="danger" icon="el-icon-plus" @click="addAction">{{
              $t('smartRouting.actionLibrary.addAction')
            }}</el-button>
          </el-form-item>
        </div>
      </template>
    </Filter>

    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column prop="code" :label="$t('smartRouting.actionLibrary.code')" />
      <el-table-column prop="name" :label="$t('smartRouting.actionLibrary.name')" />
      <el-table-column prop="type" :label="$t('smartRouting.actionLibrary.type')">
        <template #default="{ row }">
          {{ typeMap[row.type] || row.type }}
        </template>
      </el-table-column>
      <el-table-column prop="model" :label="$t('smartRouting.actionLibrary.model')">
        <template #default="{ row }">
          {{ row.model }}
        </template>
      </el-table-column>
      <el-table-column prop="tags" :label="$t('smartRouting.actionLibrary.tags')" width="240">
        <template #default="{ row }">
          <el-tag
            v-for="(tag, index) in displayedTags(row.tags)"
            :key="index"
            size="small"
            type="primary"
            effect="plain"
            class="action-tag"
          >
            {{ tag }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" :label="$t('smartRouting.actionLibrary.creator')" />
      <el-table-column prop="createTime" :label="$t('smartRouting.actionLibrary.createTime')" />
      <el-table-column prop="updateBy" :label="$t('smartRouting.actionLibrary.updater')" />
      <el-table-column prop="updateTime" :label="$t('smartRouting.actionLibrary.updateTime')" />
      <el-table-column :label="$t('smartRouting.actionLibrary.operation')" fixed="right" width="120">
        <template #default="{ row }">
          <el-tooltip class="item" effect="dark" :content="$t('smartRouting.actionLibrary.view')">
            <el-button type="text" size="" icon="el-icon-view" @click="viewAction(row)" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('smartRouting.actionLibrary.edit')">
            <el-button type="text" size="" icon="el-icon-edit" @click="editAction(row)" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('smartRouting.actionLibrary.dispatch')">
            <el-button type="text" size="" icon="el-icon-position" @click="openDispatch(row)" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('smartRouting.actionLibrary.delete')">
            <el-button type="text" size="" style="color: red;" icon="el-icon-delete" @click="deleteAction(row)" />
          </el-tooltip>
        </template>
      </el-table-column>
    </Table>

    <!-- 新增 / 编辑动作 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      width="600px"
      destroy-on-close
      :append-to-body="true"
    >
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="120px">
        <!-- <el-form-item :label="$t('smartRouting.actionLibrary.code')" v-if="isEdit">
          <el-input v-model="form.code" disabled />
        </el-form-item> -->
        <el-form-item :label="$t('smartRouting.actionLibrary.name')" prop="name">
          <el-input v-model="form.name" :placeholder="$t('smartRouting.actionLibrary.namePlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('smartRouting.actionLibrary.tags')">
          <el-input v-model="form.tags" :placeholder="$t('smartRouting.actionLibrary.tagPlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('smartRouting.actionLibrary.actionFile')" prop="filePath">
          <div class="upload-box" @click="triggerFileSelect">
            <div class="upload-info">
              <div v-if="form.fileName" class="file-name">
                <!-- <span class="file-dot" /> -->
                <span>{{ form.fileName }}</span>
              </div>
              <div v-else class="upload-placeholder">{{ $t('smartRouting.actionLibrary.selectFile') }}</div>
              <div class="upload-tip">{{ $t('smartRouting.actionLibrary.actionFileTip') }}</div>
            </div>
            <el-button size="small" type="primary" plain @click.stop="triggerFileSelect">
              {{ form.filePath ? $t('smartRouting.actionLibrary.reUpload') : $t('smartRouting.actionLibrary.selectFile') }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item :label="$t('smartRouting.actionLibrary.type')" prop="type">
          <el-select v-model="form.type" :placeholder="$t('smartRouting.actionLibrary.typePlaceholder')" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('smartRouting.actionLibrary.model')">
          <el-input v-model="form.model" :placeholder="$t('smartRouting.actionLibrary.modelPlaceholder')" />
        </el-form-item>
      </el-form>
      <input
        ref="fileInputRef"
        type="file"
        accept=".tar.gz,.gz,.tar"
        style="display: none"
        @change="onFileChange"
      />
      <template #footer>
        <el-button @click="dialogVisible = false">{{ $t('smartRouting.actionLibrary.cancel') }}</el-button>
        <el-button type="danger" @click="submitAction">{{ isEdit ? $t('smartRouting.actionLibrary.save') : $t('smartRouting.actionLibrary.confirm') }}</el-button>
      </template>
    </el-dialog>

    <!-- 查看动作 -->
    <el-dialog
      :title="$t('smartRouting.actionLibrary.viewTitle')"
      v-model="viewVisible"
      width="600px"
      destroy-on-close
      :append-to-body="true"
    >
      <el-form label-width="120px" class="view-form">
        <el-form-item :label="$t('smartRouting.actionLibrary.name')">
          <el-input v-model="detail.name" disabled />
        </el-form-item>
        <el-form-item :label="$t('smartRouting.actionLibrary.tags')">
          <el-tag
            v-for="(tag, index) in displayedTags(detail.tags)"
            :key="index"
            size="small"
            type="primary"
            effect="plain"
            class="action-tag"
          >
            {{ tag }}
          </el-tag>
        </el-form-item>
        <el-form-item :label="$t('smartRouting.actionLibrary.actionFile')">
          <div class="view-file">
            <!-- <span class="file-dot" /> -->
            <span>{{ detail.fileName || '' }}</span>
          </div>
        </el-form-item>
        <el-form-item :label="$t('smartRouting.actionLibrary.type')">
          <el-input :model-value="typeMap[detail.type] || detail.type" disabled />
        </el-form-item>
        <el-form-item :label="$t('smartRouting.actionLibrary.model')">
          <el-input :model-value="detail.model" disabled />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="viewVisible = false">{{ $t('smartRouting.actionLibrary.close') }}</el-button>
      </template>
    </el-dialog>

    <!-- 动作库下发 -->
    <el-dialog
      :title="$t('smartRouting.actionLibrary.dispatchTitle')"
      v-model="dispatchVisible"
      destroy-on-close
      width="800px"
      top="5vh"
      :append-to-body="true"
      @closed="onDispatchClosed"
    >
      <div class="dispatch-steps">
        <div class="step" :class="{ active: dispatchStep === 1, done: dispatchStep > 1 }">
          <span class="step-index">
            <i v-if="dispatchStep > 1" class="el-icon-check" />
            <template v-else>1</template>
          </span>
          <span class="step-title">{{ $t('smartRouting.actionLibrary.stepSelectDevice') }}</span>
        </div>
        <div class="step-line" />
        <div class="step" :class="{ active: dispatchStep === 2, done: dispatchStep > 2 }">
          <span class="step-index">
            <i v-if="dispatchStep > 2" class="el-icon-check" />
            <template v-else>2</template>
          </span>
          <span class="step-title">{{ $t('smartRouting.actionLibrary.stepPreCheck') }}</span>
        </div>
        <div class="step-line" />
        <div class="step" :class="{ active: dispatchStep === 3 }">
          <span class="step-index">3</span>
          <span class="step-title">{{ $t('smartRouting.actionLibrary.stepDeploy') }}</span>
        </div>
      </div>

      <!-- 步骤 1：选择目标设备 -->
      <div v-if="dispatchStep === 1">
        <el-alert :title="dispatchTip" type="info" :closable="false" class="dispatch-alert" />
        <div class="dispatch-section">
          <div class="section-title">{{ $t('smartRouting.actionLibrary.dispatchStrategy') }}</div>
          <el-radio-group v-model="strategy" size="small">
            <el-radio-button label="FULL">{{ $t('smartRouting.actionLibrary.fullAmount') }}</el-radio-button>
            <!-- <el-radio-button label="GRAY">{{ $t('smartRouting.actionLibrary.grayscale') }}</el-radio-button>
            <el-radio-button label="INCR">{{ $t('smartRouting.actionLibrary.increment') }}</el-radio-button> -->
          </el-radio-group>
          <p class="strategy-desc">{{ strategyDesc }}</p>
        </div>
        <div class="dispatch-section">
          <div class="section-title">
            {{ $t('smartRouting.actionLibrary.targetDevice') }}
            <span class="selected-info">
              {{ $t('smartRouting.actionLibrary.selectedCount', { selected: selectedCount, total: deviceTotal }) }}
              {{ $t('smartRouting.actionLibrary.excludedCount', { count: excludedCount }) }}
            </span>
          </div>
          <el-table
            :data="deviceList"
            size="small"
            max-height="300"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" :selectable="isSelectable" />
            <el-table-column prop="deviceCode" :label="$t('smartRouting.actionLibrary.sn')" />
            <el-table-column prop="deviceName" :label="$t('smartRouting.actionLibrary.deviceName')" />
            <el-table-column prop="model" :label="$t('smartRouting.actionLibrary.deviceModel')" width="120" />
            <el-table-column prop="deviceStatus" :label="$t('smartRouting.actionLibrary.status')" width="120">
              <template #default="{ row }">
                <el-tag
                  v-if="row.deviceStatus"
                  size="small"
                  :type="row.deviceStatus === 'ONLINE' ? 'success' : row.deviceStatus === 'fault' ? 'info' : 'info'"
                >
                  {{ statusText(row.deviceStatus) }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 步骤 2：部署预检 -->
      <div v-else-if="dispatchStep === 2">
        <el-alert :title="preCheckTip" type="info" :closable="false" class="dispatch-alert" />
        <div v-if="preChecking" class="pre-checking">{{ $t('smartRouting.actionLibrary.preChecking') }}</div>
        <div v-else class="pre-check-list">
          <div class="pre-check-card">
            <i
              class="pre-check-icon"
              :class="allOnline ? 'el-icon-circle-check' : 'el-icon-warning-outline'"
              :style="{ color: allOnline ? '#67c23a' : '#e6a23c' }"
            />
            <div class="pre-check-info">
              <div class="pre-check-name">{{ $t('smartRouting.actionLibrary.deviceOnlineStatus') }}</div>
              <div class="pre-check-desc">
                <template v-if="allOnline">
                  {{ $t('smartRouting.actionLibrary.deviceOnlineDescAll', { count: onlineCount }) }}
                </template>
                <template v-else>
                  {{ $t('smartRouting.actionLibrary.deviceOnlineDescPart', { online: onlineCount, total: selectedCount }) }}
                </template>
              </div>
            </div>
          </div>
          <div class="pre-check-card">
            <i class="pre-check-icon el-icon-circle-check" style="color: #67c23a;" />
            <div class="pre-check-info">
              <div class="pre-check-name">{{ $t('smartRouting.actionLibrary.actionCompat') }}</div>
              <div class="pre-check-desc">{{ $t('smartRouting.actionLibrary.actionCompatDesc') }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 步骤 3：配置下发 -->
      <div v-else>
        <el-alert :title="deployingBanner" type="info" :closable="false" class="dispatch-alert" />
        <div class="deploy-progress">
          <el-progress
            :percentage="deployProgress"
            :status="progressStatus"
            :stroke-width="8"
            :show-text="false"
          />
          <div class="deploy-status">
            <template v-if="deployStatus === 'running'">
              <span class="status-running">{{ $t('smartRouting.actionLibrary.deploying') }}</span>
            </template>
            <template v-else-if="deployStatus === 'success'">
              <i class="el-icon-circle-check" style="color: #67c23a;" />
              <span style="color: #67c23a;">{{ $t('smartRouting.actionLibrary.deployComplete') }}</span>
            </template>
            <template v-else-if="deployStatus === 'fail'">
              <i class="el-icon-circle-close" style="color: #f56c6c;" />
              <span style="color: #f56c6c;">{{ $t('smartRouting.actionLibrary.deployFail') }}</span>
            </template>
          </div>
        </div>
        <div v-if="deployStatus === 'success'" class="deploy-result">
          <div class="deploy-result-title">
            <span class="result-dot" />
            {{ $t('smartRouting.actionLibrary.deployComplete') }}
          </div>
          <div class="deploy-result-desc">{{ deployResultDesc }}</div>
        </div>
      </div>

      <template #footer>
        <div class="dispatch-footer">
          <template v-if="dispatchStep === 1">
            <el-button @click="dispatchVisible = false">{{ $t('smartRouting.actionLibrary.cancel') }}</el-button>
            <el-button type="danger" @click="nextStep">{{ $t('smartRouting.actionLibrary.nextPreCheck') }}</el-button>
          </template>
          <template v-else-if="dispatchStep === 2">
            <el-button @click="prevStep">{{ $t('smartRouting.actionLibrary.prevStep') }}</el-button>
            <el-button
              type="danger"
              :disabled="!preCheckResult.onlineDevices?.length"
              @click="startDeploy"
            >
              {{ $t('smartRouting.actionLibrary.confirmDeploy') }}
            </el-button>
          </template>
          <template v-else>
            <span v-if="deploying" class="footer-deploying">{{ $t('smartRouting.actionLibrary.deploying') }}</span>
            <el-button v-else-if="deployStatus === 'success'" type="danger" @click="finishDispatch">
              {{ $t('smartRouting.actionLibrary.complete') }}
            </el-button>
            <template v-else-if="deployStatus === 'fail'">
              <el-button @click="prevStep">{{ $t('smartRouting.actionLibrary.prevStep') }}</el-button>
              <el-button type="danger" @click="startDeploy">{{ $t('smartRouting.actionLibrary.retry') }}</el-button>
            </template>
          </template>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { common } from '@/common/mixin';
import Table from '@/components/table/index';
import Filter from '@/components/table/filter';
import { ElMessageBox, ElMessage } from 'element-plus';
import { reactive, toRefs, ref, computed } from '@vue/reactivity';
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';
import * as Api from '@/api/smartRouting/action';
import { ossUpload } from '@/utils/oss';
import { arrayToMap } from '@/utils/index'

export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  setup() {
    const { t } = useI18n();
    const formRef = ref(null);
    const fileInputRef = ref(null);

    const typeList = [
      { label: t('smartRouting.actionLibrary.typeList[0]'), value: 'MIMIC' },
      { label: t('smartRouting.actionLibrary.typeList[1]'), value: 'UPPER' }
    ];
    const typeMap = arrayToMap(typeList, 'value', 'label')

    const params = [
      {
        key: 'name',
        value: '',
        label: t('smartRouting.actionLibrary.name'),
        placeholder: t('smartRouting.actionLibrary.enterName')
      },
      {
        key: 'tag',
        value: '',
        label: t('smartRouting.actionLibrary.tag'),
        placeholder: t('smartRouting.actionLibrary.enterTag')
      }
    ];

    const state = reactive({
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      dialogVisible: false,
      isEdit: false,
      viewVisible: false,
      form: {
        code: '',
        name: '',
        type: '',
        model: '',
        tags: '',
        filePath: '',
        fileName: '',
        fileUrl: ''
      },
      detail: {},
      dispatchVisible: false,
      dispatchStep: 1,
      currentAction: null,
      strategy: '',
      deviceList: [],
      selectedDevices: [],
      preChecking: false,
      preCheckResult: {},
      deploying: false,
      deployProgress: 0,
      deployStatus: ''
    });

    const dialogTitle = computed(() => {
      return state.isEdit
        ? t('smartRouting.actionLibrary.editTitle')
        : t('smartRouting.actionLibrary.addTitle');
    });

    const formRules = {
      name: {
        required: true,
        message: t('smartRouting.actionLibrary.nameRequired'),
        trigger: 'blur'
      },
      filePath: {
        required: true,
        message: t('smartRouting.actionLibrary.actionFileRequired'),
        trigger: 'change'
      },
      type: {
        required: true,
        message: t('smartRouting.actionLibrary.typePlaceholder'),
        trigger: 'change'
      }
    };

    const selectedCount = computed(() => {
      return state.selectedDevices.length;
    });

    const deviceTotal = computed(() => {
      return state.deviceList.filter((item) => item.deviceStatus !== 'fault').length;
    });

    const excludedCount = computed(() => {
      return state.deviceList.filter((item) => item.deviceStatus === 'fault').length;
    });

    const strategyDesc = computed(() => {
      const map = {
        FULL: t('smartRouting.actionLibrary.fullAmountDesc'),
        GRAY: t('smartRouting.actionLibrary.grayscaleDesc'),
        INCR: t('smartRouting.actionLibrary.incrementDesc')
      };
      return map[state.strategy] || '';
    });

    const strategyText = computed(() => {
      const map = {
        FULL: t('smartRouting.actionLibrary.fullAmount'),
        GRAY: t('smartRouting.actionLibrary.grayscale'),
        INCR: t('smartRouting.actionLibrary.increment')
      };
      return map[state.strategy] || '';
    });

    const dispatchTip = computed(() => {
      return t('smartRouting.actionLibrary.dispatchTip', {
        name: state.currentAction?.name || '',
        file: state.currentAction?.fileName || ''
      });
    });

    const preCheckTip = computed(() => {
      return t('smartRouting.actionLibrary.preCheckTip', {
        name: state.currentAction?.name || '',
        count: state.selectedDevices.length
      });
    });

    const onlineCount = computed(() => {
      return state.preCheckResult.onlineDevices?.length || state.selectedDevices.length;
    });

    const allOnline = computed(() => {
      return onlineCount.value === state.selectedDevices.length;
    });

    const deployingBanner = computed(() => {
      return t('smartRouting.actionLibrary.deployingBanner', {
        count: onlineCount.value,
        name: state.currentAction?.name || '',
        strategy: strategyText.value
      });
    });

    const deployResultDesc = computed(() => {
      const names = state.selectedDevices.map((item) => item.deviceName).filter(Boolean);
      const devices = names.slice(0, 2).join('、') + (names.length > 2 ? ' ' + t('smartRouting.actionLibrary.etc') : '');
      return t('smartRouting.actionLibrary.deployResultDesc', {
        devices: devices,
        count: state.selectedDevices.length,
        strategy: strategyText.value,
        action: state.currentAction?.code || ''
      });
    });

    const progressStatus = computed(() => {
      if (state.deployStatus === 'success') return 'success';
      if (state.deployStatus === 'fail') return 'exception';
      return undefined;
    });

    const displayedTags = (tags) => {
      return tags?.split(/[,，]/);
    };

    const resetForm = () => {
      state.form = {
        code: '',
        name: '',
        type: '',
        model: '',
        tags: '',
        filePath: '',
        fileName: '',
        fileUrl: ''
      };
      if (fileInputRef.value) {
        fileInputRef.value.value = '';
      }
    };

    const getData = async () => {
      try {
        const res = await Api.reqActionList({
          ...state.query,
          page: state.page,
          size: state.size,
        })
        state.tableDataList = res.records || []
        state.total = Number(res.total || 0)
      } catch (error) {
        console.error(error)
      }
    };

    const searchData = (data) => {
      state.query = data;
      state.page = 1;
      getData();
    };

    const updatePage = (page, size) => {
      state.page = page || 1;
      state.size = size || 10;
      getData();
    };

    // 文件选择
    const triggerFileSelect = () => {
      fileInputRef.value?.click();
    };

    const onFileChange = async (e) => {
      const file = e.target.files?.[0];
      if (file) {
        state.form.fileName = file.name;
        state.form.filePath = 'smart/action/' + dayjs().format('YYYY/MM/DD/') + file.name;
        state.form.fileUrl = await ossUpload(file.name, file, {
          path: 'smart/action/' + dayjs().format('YYYY/MM/DD'),
          timestamp: false,
        })
      }
    };

    // 新增
    const addAction = () => {
      resetForm();
      state.isEdit = false;
      state.dialogVisible = true;
    };

    // 编辑
    const editAction = (row) => {
      resetForm();
      state.isEdit = true;
      state.form = {
        code: row.code,
        name: row.name,
        type: row.type,
        model: row.model,
        tags: row.tags,
        filePath: row.filePath || '',
        fileName: row.fileName || '',
        fileUrl: row.fileUrl || ''
      };
      state.dialogVisible = true;
    };

    const submitAction = async () => {
      try {
        await formRef.value?.validate();
        if (state.isEdit) {
          await Api.reqActionEdit(state.form);
        } else {
          await Api.reqActionAdd(state.form);
        }
        state.dialogVisible = false;
        getData();
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.list.submitSuccess')
        });
      } catch (error) {
        console.error(error);
      }
    };

    // 查看
    const viewAction = (row) => {
      state.detail = { ...row };
      state.viewVisible = true;
    };

    // 删除
    const deleteAction = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('smartRouting.actionLibrary.confirmDelete'),
          t('smartRouting.actionLibrary.prompt'),
          {
            confirmButtonText: t('activity.list.confirm1'),
            cancelButtonText: t('activity.list.cancel'),
            type: 'warning'
          }
        );
        await Api.reqActionDelete(row.code);
        getData();
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('smartRouting.actionLibrary.deleteSuccess')
        });
      } catch (error) {
        console.error(error);
      }
    };

    // 可选设备列表
    const getDeviceList = async () => {
      try {
        const res = await Api.reqDeviceList();
        state.deviceList = res || [];
      } catch (error) {
        console.error(error);
      }
    };

    // 模拟下发进度（后续可替换为真实的进度查询接口）
    let progressTimer = null;

    const clearProgress = () => {
      if (progressTimer) {
        clearInterval(progressTimer);
        progressTimer = null;
      }
    };

    const openDispatch = (row) => {
      clearProgress();
      state.currentAction = { ...row };
      state.dispatchStep = 1;
      state.strategy = 'FULL';
      state.preCheckResult = {};
      state.deploying = false;
      state.deployProgress = 0;
      state.deployStatus = '';
      getDeviceList();
      state.dispatchVisible = true;
    };

    const onDispatchClosed = () => {
      clearProgress();
      state.currentAction = null;
      state.dispatchStep = 1;
      state.strategy = '';
      state.deviceList = [];
      state.selectedDevices = [];
      state.preCheckResult = {};
      state.deploying = false;
      state.deployProgress = 0;
      state.deployStatus = '';
    };

    const isSelectable = (row) => {
      return row.deviceStatus !== 'fault';
    };

    const statusText = (status) => {
      const map = {
        ONLINE: t('smartRouting.actionLibrary.online'),
        OFFLINE: t('smartRouting.actionLibrary.offline'),
        FAULT: t('smartRouting.actionLibrary.fault')
      };
      return map[status] || status;
    };

    const handleSelectionChange = (val) => {
      state.selectedDevices = val;
    };

    const runPreCheck = async () => {
      try {
        state.preChecking = true;
        state.preCheckResult = await Api.reqDeployPrecheck({
          resourceCode: state.currentAction.code,
          resourceType: 'ACTION',
          targetDevices: state.selectedDevices.map((item) => item.deviceCode)
        });
        state.preChecking = false;
      } catch (error) {
        state.preChecking = false;
        console.error(error);
      }
    };

    const nextStep = async () => {
      if (state.dispatchStep === 1) {
        if (state.selectedDevices.length === 0) {
          ElMessage({
            showClose: true,
            type: 'warning',
            message: t('smartRouting.actionLibrary.selectedCount', { selected: 0, total: deviceTotal.value })
          });
          return;
        }
        await runPreCheck();
        state.dispatchStep = 2;
      }
    };

    const prevStep = () => {
      if (state.dispatchStep > 1) {
        state.dispatchStep -= 1;
      }
    };

    // 确认下发：立即提交下发请求并进入第三步，展示模拟进度条
    const startDeploy = async () => {
      clearProgress();
      state.dispatchStep = 3;
      state.deploying = true;
      state.deployStatus = 'running';
      state.deployProgress = 0;
      progressTimer = setInterval(() => {
        if (state.deployProgress < 90) {
          state.deployProgress = Math.min(90, state.deployProgress + 5 + Math.random() * 10);
        }
      }, 200);
      try {
        await Api.reqDeployAction({
          actionCode: state.currentAction.code,
          fileList: [{
            fileUrl: state.currentAction.fileUrl,
            resourceCode: state.currentAction.code,
            resourceName: state.currentAction.name,
            resourceType: 'ACTION'
          }],
          strategy: state.strategy,
          targetDevices: state.preCheckResult.onlineDevices || []
        });
        clearProgress();
        state.deployProgress = 100;
        state.deployStatus = 'success';
      } catch (error) {
        clearProgress();
        state.deployStatus = 'fail';
        console.error(error);
      } finally {
        state.deploying = false;
      }
    };

    const finishDispatch = () => {
      state.dispatchVisible = false;
      // ElMessage({
      //   showClose: true,
      //   type: 'success',
      //   message: t('smartRouting.actionLibrary.deploySuccess')
      // });
    };

    // 页面初始化
    getData();

    return {
      ...toRefs(state),
      params,
      formRef,
      fileInputRef,
      formRules,
      dialogTitle,
      typeList,
      typeMap,
      selectedCount,
      deviceTotal,
      excludedCount,
      strategyDesc,
      strategyText,
      dispatchTip,
      preCheckTip,
      onlineCount,
      allOnline,
      deployingBanner,
      deployResultDesc,
      progressStatus,
      displayedTags,
      statusText,
      getData,
      searchData,
      updatePage,
      triggerFileSelect,
      onFileChange,
      addAction,
      editAction,
      submitAction,
      viewAction,
      deleteAction,
      openDispatch,
      onDispatchClosed,
      isSelectable,
      handleSelectionChange,
      nextStep,
      prevStep,
      startDeploy,
      finishDispatch
    };
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.handle-btns {
  margin-left: auto;
  margin-right: 0;
}

.action-tag {
  border-radius: 12px;
  margin-right: 6px;
}

.view-file {
  display: flex;
  align-items: center;
  color: #67c23a;
}

.file-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #67c23a;
  margin-right: 8px;
}

.upload-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  background-color: #fafafa;
  cursor: pointer;
}

.upload-box:hover {
  border-color: #409eff;
}

.upload-info {
  flex: 1;
}

.upload-placeholder {
  color: #c0c4cc;
}

.file-name {
  display: flex;
  align-items: center;
  color: #67c23a;
  margin-bottom: 6px;
}

.upload-tip {
  color: #909399;
  font-size: 12px;
}

.dispatch-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #909399;
}

.step.active {
  color: #409eff;
}

.step-index {
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 50%;
  background-color: #f0f2f5;
  color: #909399;
  font-size: 14px;
  margin-bottom: 6px;
}

.step.active .step-index {
  background-color: #409eff;
  color: #fff;
}

.step.done {
  color: #67c23a;
}

.step.done .step-index {
  background-color: #67c23a;
  color: #fff;
}

.step-line {
  width: 80px;
  height: 1px;
  background-color: #dcdfe6;
  margin: 0 12px;
  margin-bottom: 24px;
}

.dispatch-alert {
  margin-bottom: 16px;
  background-color: #EAF4FF;
  border-radius: 4px;
  color: #303133;
}

.dispatch-section {
  margin-bottom: 20px;
}

.section-title {
  font-weight: 600;
  margin-bottom: 10px;
  color: #303133;
}

.selected-info {
  font-weight: normal;
  color: #909399;
  font-size: 13px;
  margin-left: 10px;
}

.strategy-desc {
  color: #909399;
  font-size: 13px;
  margin-top: 8px;
}

.pre-checking {
  color: #909399;
  padding: 20px 0;
  text-align: center;
}

.pre-check-list {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
}

.pre-check-card {
  display: flex;
  align-items: flex-start;
  padding: 14px 16px;
  border-bottom: 1px solid #ebeef5;
}

.pre-check-card:last-child {
  border-bottom: none;
}

.pre-check-icon {
  font-size: 18px;
  margin-right: 10px;
  margin-top: 1px;
}

.pre-check-name {
  font-weight: 500;
  margin-bottom: 4px;
}

.pre-check-desc {
  color: #909399;
  font-size: 13px;
}

.deploy-progress {
  margin-top: 4px;
}

.deploy-status {
  display: flex;
  align-items: center;
  margin-top: 8px;
  font-size: 13px;
}

.deploy-status i {
  margin-right: 6px;
}

.status-running {
  color: #409eff;
}

.deploy-result {
  margin-top: 16px;
  background-color: #f5f7fa;
  border-radius: 6px;
  padding: 14px 16px;
}

.deploy-result-title {
  display: flex;
  align-items: center;
  font-weight: 500;
  margin-bottom: 6px;
}

.result-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #409eff;
  margin-right: 8px;
}

.deploy-result-desc {
  color: #909399;
  font-size: 13px;
}

.dispatch-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.dispatch-footer .el-button + .el-button {
  margin-left: 10px;
}

.footer-deploying {
  color: #909399;
  font-size: 13px;
}
</style>
